<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>突合結果</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" style="min-width: 495px;">
                <ng-container matColumnDef="receivemoneyyoteiMny">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 130px;">
                        入金予定明細合計額[円]</th>
                    <td mat-cell class="mat-cell-right" *matCellDef="let row">{{row.receivemoneyyoteiMny | number}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="kouzaDepositreportAmt">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 105px;">
                        口座入金報告額[円]</th>
                    <td mat-cell class="mat-cell-right" *matCellDef="let row">{{row.kouzaDepositreportAmt | number}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="feeTotalamountAmt">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 155px;">
                        入金手数料明細合計金額[円]</th>
                    <td mat-cell class="mat-cell-right" *matCellDef="let row">{{row.feeTotalamountAmt | number}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="kafusokuMny">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 105px;">
                        過不足金額[円]</th>
                    <td mat-cell class="mat-cell-right" *matCellDef="let row">{{row.kafusokuMny | number}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsCol;sticky:true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsCol"></tr>
            </table>
        </div>

    </mat-card-content>
</mat-card>